var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"r":"18","transform":"matrix(-1 0 0 1 18 18)","fill":"#DEEDED","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1849 17.8984L18.8849 24.8348C19.1314 25.0551 19.53 25.0551 19.7766 24.8348L20.8151 23.9068C21.0616 23.6865 21.0616 23.3303 20.8151 23.1101L14.5995 17.5L20.8151 11.8899C21.0616 11.6697 21.0616 11.3135 20.8151 11.0932L19.7766 10.1652C19.53 9.94493 19.1314 9.94493 18.8849 10.1652L11.1849 17.1016C10.9384 17.3219 10.9384 17.6781 11.1849 17.8984Z","fill":"#20B4B3","key":1})]);
}

Arrow.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
